import React from 'react'
import DynamicBanner from './DynamicBanner'
import DynamicInfra from './DynamicInfra';
import DynamicFeatures from './DynamicFeatures';
import DynamicCounter from './DynamicCounter';
import DynamicSolutions from './DynamicSolutions';
import DynamicService from './DynamicService';
import HealthcareBrand from '../Industries/Healthcare/HealthcareBrand';
import DynamicTestimonial from './DynamicTestimonial';
import HomeProducts from '../home/HomeProducts';
import DynamicFaq from './DynamicFaq';
import { BaseUrl } from '../../helper/BaseUrl';
import { useNavigate, useParams } from 'react-router-dom';

export default function DynamicPage({ initialData }) {

  const [aiData, setAiData] = React.useState(initialData?.detailpage || []);
  const { dynamic_slug } = useParams();
  const navigate = useNavigate();


// APi Fetching
  const aifetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/dynamic-page/view/${dynamic_slug}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (!result.dynamicpage) {
        navigate("/404");
        return;
      }
      setAiData(result.dynamicpage);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  React.useEffect(() => {
    aifetcher();
  }, [dynamic_slug])

  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        name: aiData?.section1_title
          ? aiData.section1_title.length > 18
            ? aiData.section1_title.slice(0, 18) + "..."
            : aiData.section1_title
          : "",
      }
    ]
  };

  const LogosData = {
    title: "",
    logos: [
      { image: "/assets/images/hospital-logos6.webp", title: "Brand 1" },
      { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
      { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
      { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
      { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
      { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
      { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
      { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
    ]
  };

  const productData = {
    subtitle: "Recommended Products",
    title: "Advanced Commercial Laundry <br> Solutions for Every Industry",
  };
  const faqData = {
    title: "FAQs",
    description: "Clear answers to help you choose the right healthcare laundry solution confidently.",
    buttonText: "Talk to an expert",
    buttonLink: "/contact",

  };

  return (
    <>
      <DynamicBanner data={aiData} breadcrumb={bannerData.breadcrumb} />
      <DynamicInfra data={aiData} />
      <DynamicFeatures data={aiData} />
      <DynamicCounter data={aiData} />
      <DynamicSolutions data={aiData} />
      <DynamicService data={aiData} />
      <HealthcareBrand data={LogosData} />
      <DynamicTestimonial data={aiData} />
      <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData?.listpage} />
      <DynamicFaq data={faqData} aiData={aiData} />
    </>
  )
}
